import React, { useState } from 'react'
import { Modal, ModalProps } from './Modal'

// Hàm mã hóa/giải mã base64
const encode = (str: string) => btoa(unescape(encodeURIComponent(str)))
const decode = (str: string) => decodeURIComponent(escape(atob(str)))

// Username/password đã mã hóa base64
const USERNAME = 'bGVl' // 'lee'
const PASSWORD = 'bGVlQFBhbmdv' // 'lee@Pango'
const STORAGE_KEY = 'pangoconnect_user'

export const LoginModal: React.FC<Pick<ModalProps, 'isOpen'>> = ({ isOpen }) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    setTimeout(() => {
      if (encode(username) === USERNAME && encode(password) === PASSWORD) {
        localStorage.setItem(STORAGE_KEY, encode(JSON.stringify({ username: encode(username) })))
        window.location.reload()
      } else {
        setError('Invalid username or password!')
        setLoading(false)
      }
    }, 600)
  }

  return (
    <Modal isOpen={isOpen} onClose={() => {}} hideHeader disableClose>
      <form onSubmit={handleLogin} className="flex flex-col gap-4 p-6 min-w-[300px] items-center">
        <img src="https://api.dicebear.com/9.x/bottts/svg?seed=Liam&baseColor=1e88e5,43a047,5e35b1,6d4c41,757575,7cb342,8e24aa,c0ca33,d81b60,e53935,f4511e,fb8c00,fdd835,ffb300,039be5&eyes=happy,hearts,robocop,round,roundFrame01,roundFrame02,sensor,shade01,bulging,dizzy,glow,frame1,eva&face=square01,square02,round02,square03,square04&mouth=bite,diagram,grill01,grill02,grill03,smile02,smile01,square02" className="w-32 h-32"/>
        <h2 className="text-3xl font-bold text-center text-gray-800">P.Connext Demo</h2>
        <div className="text-gray-700 text-center text-sm mb-4">
            Pango's specialized CRM for the Farming model. Log in to unlock the transformative power of integrated CRM, CDP, and AI<br/>
        </div>
        <input
          className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoFocus
        />
        <input
          className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
          placeholder="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {error && <div className="text-red-600 text-sm text-center w-full">{error}</div>}
        <button
          type="submit"
          className="bg-blue-600 text-white rounded-lg py-2 font-semibold hover:bg-blue-700 transition-colors disabled:opacity-60 w-full mt-2"
          disabled={loading || !username || !password}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <div className="text-sm text-gray-500 text-center pt-4 px-4">
          Request your demo account by emailing: <a href="mailto:lee@bytetech.io" className="text-blue-600 underline">lee@bytetech.io</a>
        </div>
      </form>
    </Modal>
  )
} 